import { useFormik } from 'formik';
import { initialValues } from './formData';
import { LegalProceedingFilter } from '../../../../../shared/types/legalProceedings/legalProceedings';
import { cleanObj } from '../../../../../shared/utils/objects';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../services/param.service';

export const useLegalProceedingsFilters = (
    onFilter?: (data: LegalProceedingFilter) => void
) => {
    const [statusList, setStatusList] = useState<ISelect[]>([]);

    const onSubmit = (data: LegalProceedingFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.JUDICIAL_STATUS).then((items) =>
            setStatusList(items)
        );
    }, []);

    return {
        formik,
        statusList,
    };
};
